@if ('showLinkToPrivacyPolicy' | feature | async) {
	@if (user()) {
		<div>
			<a [routerLink]="'/img/Datenschutz_' + user().uiLanguage + '.pdf'" target="_blank">
				{{"frame.footer.datenschutz" | msgKey}}
			</a>
		</div>
	} @else {
		@if ('showLinkToPrivacyPolicyBeforeLogin' | feature | async) {
			<div>
				<a [routerLink]="'/img/Datenschutz_' + ('i18nDefaultUiLanguage' | featureValue | async) + '.pdf'" target="_blank">
					{{"frame.footer.datenschutz" | msgKey}}
				</a>
			</div>
		}
	}
}
